const $ = jQuery;

export default function () {
	$(window).load(() => {
		const backToButton = $('.et_pb_scroll_top');
		const skipToContent = $('.skip-link');
		if (($(backToButton).length) && ($(skipToContent).length)) {
			backToButton.off('click');
			backToButton.on('click', () => {
				$('html, body').animate({
					scrollTop: 0,
				}, 800);
				skipToContent.focus();
			});
		}
		backToButton.attr('role', 'button').attr('tabindex', '0').attr('aria-label', 'Back To Top');
		backToButton.on('keydown', function (event) {
			if (event.which === 13) {
				event.preventDefault();
				$(this).click();
			}
		});
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/back-to-top-link.js